import CONSTANTS from '../../../constants';

export function category(state = { data: null, loading: true }, action) {
  if (action.type === CONSTANTS.ACTIONS.CATEGORY.CATEGORY_CREATE) {
    const { data } = action;
    return { data: data ? data.response : data, loading: action.loading};
  }
  return state;
}